import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import SuccessMessage from '../../../components/successMessage';
import ErrorMessage from '../../../components/errorMessage';
import Loading from '../../../components/loading';
import LaboratoryListContent from './laboratoryListContent';
import { useLaboratoryListScreen } from '../hooks/useLaboratoryListScreen';

export default function LaboratoryListWeb() {
  const screen = useLaboratoryListScreen();
  const {
    isLoading,
    openCreateModal,
    showSuccessMessage,
    setShowSuccessMessage,
    successMessage,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
  } = screen;

  return (
    <>
      <Loading isToHidden={isLoading === false} />
      {showSuccessMessage && (
        <SuccessMessage
          message={successMessage}
          show={showSuccessMessage}
          setShow={setShowSuccessMessage}
        />
      )}
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <Box sx={{ p: 4 }}>
        <Container maxWidth="lg">
          <Paper elevation={0} variant="outlined" sx={{ p: 4, borderRadius: '12px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
              }}
            >
              <Typography variant="h5" component="h1" sx={{ fontWeight: '600' }}>
                Laboratórios
              </Typography>
              <Button variant="outlined" onClick={openCreateModal} data-cy="add-laboratory-btn">
                Adicionar Laboratório
              </Button>
            </Box>

            <LaboratoryListContent screen={screen} />
          </Paper>
        </Container>
      </Box>
    </>
  );
}
